import { useTranslation } from 'react-i18next'
import React from 'react'

import IconText from '../../packages/kiti/components/presentation/IconText'
import { useIntegrationList } from '../../modules/fields/edit/_load/IntegrationsLoader'
import LogoText from '../../packages/kiti/components/presentation/LogoText'
import { INTEGRATION_LOGO } from '../../modules/fields/edit/_data/integrationLogos'

const ICONS = {
  action_plan: 'BsCardChecklist',
  checkbox: 'BsToggleOn',
  compliance: 'BsCheckAll',
  cpf_cnpj: 'BsCardHeading',
  date: 'BsCalendar',
  datetime: 'BsAlarm',
  time: 'BsClock',
  compliance: 'BsClipboard',
  gallery: 'BsImages',
  multiple: 'BsCheckSquare',
  pending: 'BsExclamationTriangle',
  select: 'BsCheckCircle',
  sign: 'BsPen',
  signature: 'BsPen',
  stock: 'BsPower',
  system_status: 'BsPower',
  address: 'BsGeoAlt',
  location: 'BsGeoAlt',
  numeric: 'BsFillGrid3X3GapFill',
  number: 'BsGrid3X3Gap',
  integer: 'BsGrid3X3Gap',
  float: 'BsFillGrid3X3GapFill',
  text: 'BsJustifyLeft',
  email: 'RiMailLine',
  place_location: 'BsGeoAlt',
  place_person: 'BsFillPeopleFill',
  tags: 'BsListTask',
  integration: 'RiLinksFill'
}

const FieldTypeIconText = ({ field, type }) => {
  const { t } = useTranslation()
  const integrationList = useIntegrationList()

  const integrationPath = field?.configuration
  const hasIntegration = integrationList.includes(integrationPath?.integrationService)

  return (
    <>
      {hasIntegration ? (
        <LogoText
          label={integrationPath?.integrationFieldType}
          logoLeft={INTEGRATION_LOGO[integrationPath?.integrationService]}
        />
      ) : (
        <IconText label={t('fieldTypes.' + type)} iconLeft={ICONS[type]} iconSize={0.9} />
      )}
    </>
  )
}

export default FieldTypeIconText
